<!-- src/views/AvailablePositions.vue -->
<template>
  <div class="available-positions-page">
    <h1>Available Positions</h1>
    <p class="intro">
      Join one of our partner companies and start your career today.
      Explore current openings below:
    </p>

    <div class="positions-list">
      <div
        v-for="job in positions"
        :key="job.id"
        class="position-card"
      >
        <h2>{{ job.title }}</h2>
        <p class="company">{{ job.company }}</p>
        <p class="location">{{ job.location }}</p>
        <p class="summary">{{ job.description }}</p>
        <router-link to="/apply" class="apply-link">
          Apply Now
        </router-link>
      </div>
      <div v-if="positions.length === 0" class="no-positions">
        No positions are currently available. Please check back later.
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import {
  collection,
  onSnapshot
} from 'firebase/firestore'
import { db } from '@/firebase'

const positions = ref([])
let unsubscribe = null

onMounted(() => {
  // Listen to the "jobs" collection in Firestore
  const jobsCol = collection(db, 'jobs')
  unsubscribe = onSnapshot(
    jobsCol,
    (snapshot) => {
      positions.value = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    },
    (err) => {
      console.error('Error fetching job listings:', err)
    }
  )
})

onUnmounted(() => {
  if (unsubscribe) unsubscribe()
})
</script>

<style scoped>
.available-positions-page {
  max-width: 900px;
  margin: 2rem auto;
  padding: 2rem;
  background: #fff;
}

h1 {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 1rem;
}

.intro {
  text-align: center;
  color: #555;
  margin-bottom: 2rem;
}

.positions-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.position-card {
  padding: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  background: #fafafa;
}

.position-card h2 {
  font-size: 1.5rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.company {
  font-weight: bold;
  color: #3498db;
  margin-bottom: 0.5rem;
}

.location {
  font-style: italic;
  color: #7f8c8d;
  margin-bottom: 0.5rem;
}

.summary {
  margin-bottom: 1rem;
}

.apply-link {
  color: #fff;
  background-color: #3498db;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  text-decoration: none;
  font-weight: bold;
}

.apply-link:hover {
  background-color: #2980b9;
}

.no-positions {
  text-align: center;
  color: #777;
  font-style: italic;
  padding: 2rem;
}
</style>
